export default __webpack_public_path__ + "static/media/john_savino.fa1ed14e.pdf";